import { render, staticRenderFns } from "./referral-card.vue?vue&type=template&id=f606ba5a&"
import script from "./referral-card.vue?vue&type=script&lang=js&"
export * from "./referral-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports